export default "__VITE_ASSET__CGhjktDR__"